import { StyleSheet } from 'aphrodite';

const animationPulse = {
	'50%': {
		opacity: 0.5,
	},
};

export const s = StyleSheet.create({
	root: {
		backgroundColor: `#f5f5f5`,
		animationDuration: '2s',
		animationTimingFunction: `cubic-bezier(0.4, 0, 0.6, 1)`,
		animationIterationCount: 'infinite',
		animationName: animationPulse,
	},
});
